import { render } from "./CommentForm.vue?vue&type=template&id=2ffa7bc0"
import script from "./CommentForm.vue?vue&type=script&lang=js"
export * from "./CommentForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/wdw-vue build and deploy Teledata PROD/wdw-vue-widgets/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__